export const resolveVariables = (text, variableDict) => {
  if (!text || typeof text !== 'string') return '';
  
  // Replace all @variable references with their actual values
  return text.replace(/@(\w+)/g, (match, varKey) => {
    return variableDict[varKey]?.value !== undefined 
      ? String(variableDict[varKey].value) 
      : match; // Keep @variable if not found
  });
};